import { Component, OnInit, OnDestroy, Input, } from '@angular/core';
import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { curatedMentionListBlockType } from '../../models/briefings-block-types.model';
import { CuratedMentionListDisplayElementModel } from '../../models/curated-mention-list-display-element.model';
import { MentionsNoFacetFilterService } from '../../../../Common/Mentions/services/mentions-no-facet-filter.service';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { Subscription } from 'rxjs';
import { MentionSearchModel } from '../../../Shared/models/mention-search.model';
import {BriefingsService} from '../../services/briefings.service';
import { SavedSearchType } from '../../../../Common/MonitorShared/enum/saved-search-type.enum';
import { LayoutBlock } from '@Common/PageBuilder/models/layout-block.model';

@Component({
    selector: 'agpr-sort-tool-block',
    templateUrl: './sort-tool-block.component.html',
    styleUrls: ['./sort-tool-block.component.scss'],
    providers: [
        MentionsNoFacetFilterService,
        {
            provide: FilterService,
            useExisting: MentionsNoFacetFilterService
        }
    ],
    standalone: false
})
export class SortToolBlockComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];

    public _block: BlockModel;
    public curatedDisplayElement: CuratedMentionListDisplayElementModel;
    public layoutBlock: LayoutBlock;

    @Input() public id: string;
    @Input() public set block(value: BlockModel) {
        this._block = value;

        if (!value) {
            this.curatedDisplayElement = null;
            return;
        }

        const isCurated = this._block.type && this._block.type.key === curatedMentionListBlockType.key;
        if (this._block?.isLayoutBlockType()) {
            this.layoutBlock = this._block as LayoutBlock;
        }

        if (isCurated) {
            const curatedDisplayElement = this._block.displayElement as CuratedMentionListDisplayElementModel;
            this.curatedDisplayElement = curatedDisplayElement;

            const search = curatedDisplayElement.searchCriteria;

            if (search) {
                this.filterService.getFiltersFromSearch(search.searchCriteria);
            }
        } else {
            this.curatedDisplayElement = null;
        }
    }
    @Input() public selected: boolean = false;

    constructor(
        public briefingService: BriefingsService,
        public filterService: MentionsNoFacetFilterService,
    ) {
        this.filterService.setRestrictedFilters();
    }

    ngOnInit() {
        this.subscriptions.push(
            this.filterService.getSearchFilters().subscribe(
                (searchCriteria) => {
                    if (!this.curatedDisplayElement || !searchCriteria) {
                        return;
                    }
                    const curatedDisplayElement = this._block.displayElement as CuratedMentionListDisplayElementModel;
                    let search = curatedDisplayElement.searchCriteria;

                    if (!search) {
                        search = new MentionSearchModel();
                        search.type = SavedSearchType.BRIEFING;
                        search.searchCriteria = searchCriteria;
                        curatedDisplayElement.searchCriteria = search;
                        this.briefingService.formFieldUpdated();
                    } else if (!search.searchCriteria.equals(searchCriteria)) {
                        search.searchCriteria = searchCriteria;
                        this.briefingService.formFieldUpdated();
                    }
                }
            ),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((value) => {
            value.unsubscribe();
        });
    }

    cancelEvent(event: MouseEvent): boolean {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
    }
}
